import api from '@/common/api';

// Общая логика состояний плиток каталога (ТЗ, раздел 6): используют и страница «Каталог услуг»,
// и блок «Доступные к покупке» в «Обзоре» корпа.

// Сколько последних заказов разбираем, чтобы понять «куплена / ожидает оплаты»: состав есть только в детали заказа.
const ORDERS_TO_SCAN = 30;

// Услуги, которые уже есть у пользователя (в том числе с нулевым остатком)
export const OWN_STATES = ['available', 'ended', 'ask'];

// Порядок: купленные, закончившиеся, ожидающие оплаты, в корзине, не купленные (ТЗ, 6.1).
export const STATE_ORDER = ['available', 'ended', 'ask', 'pending', 'in_cart', 'not_bought', 'company_off', 'catalog'];

// id карточек каталога из оплаченных и ожидающих оплаты заказов пользователя.
export async function loadOrderedCardIds() {
  const list = await api.get('/service-catalog/purchases/', { params: { page_size: ORDERS_TO_SCAN, ordering: '-created_at' } });
  const orders = (Array.isArray(list) ? list : (list.results || [])).filter((o) => ['paid', 'pending'].includes(o.status));
  const details = await Promise.all(orders.map((o) => api.get(`/service-catalog/purchases/${o.id}/`).catch(() => null)));
  const paid = new Set();
  const pending = new Set();
  details.filter(Boolean).forEach((d) => {
    (d.items || []).forEach((i) => (d.status === 'paid' ? paid : pending).add(i.service_card_id));
  });
  return { paid: [...paid], pending: [...pending].filter((id) => !paid.has(id)) };
}

// Остаток теста корпа для карточки каталога: по сводке кошелька (nomenclature карточки = id теста в сводке).
export function walletBalanceOf(card, wallet) {
  if (card.nomenclature == null || !wallet) return { balance: null, buffer: null, known: false };
  const item = wallet.items.find((i) => String(i.id) === String(card.nomenclature));
  if (!item) return { balance: null, buffer: null, known: false };
  const known = !!(item.total.balance || item.total.received || item.total.spent || item.buffer.received);
  return { balance: item.total.balance, buffer: item.buffer.balance, known };
}

// Состояние плитки. Админ каталог только смотрит — без состояний покупки.
export function tileState({
  isAdmin, isManager, inBasket, isTest, balance, known, paid, pending,
}) {
  if (isAdmin) return 'catalog';
  if (inBasket) return 'in_cart';
  if (isTest && balance > 0) return 'available';
  if (isTest && balance === 0 && (paid || known)) return isManager ? 'ask' : 'ended';
  if (pending) return 'pending';
  // Куплена, но остаток неизвестен (не загрузился) — не пугаем «Закончилась»
  if (paid) return 'available';
  return isManager ? 'company_off' : 'not_bought';
}
